import type { DeliveryPackagingFormValues } from "../types"

import { DeliveryDateReference } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const DELIVERY_DATE_REFERENCE_LABELS: Record<DeliveryDateReference, string> = {
  [DeliveryDateReference.ShipBy]: "Shipped Date",
  [DeliveryDateReference.DeliverBy]: "Deliver By",
} as const

export const DELIVERY_DATE_REFERENCE_OPTIONS: Option<DeliveryDateReference>[] = [
  { value: DeliveryDateReference.ShipBy, label: "Shipped Date" },
  { value: DeliveryDateReference.DeliverBy, label: "Deliver By" },
]

export const DEFAULT_DELIVERY_PACKAGING = {
  preferredDeliveryDateReference: null,
  packagingInstructions: "",
  insureSmallParcel: false,
} satisfies DeliveryPackagingFormValues
